import * as React from "react";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

declare const CLIENT_BUILD_ID: string;

export function ClientVersion() {
    return (
        <div
            className={StyleClassAuto({
                marginTop: "6px",
                padding: "6px 8px 2px",
                borderTop: "1px solid rgba(255, 255, 255, 0.08)",
                color: "rgba(226, 218, 194, 0.72)",
                fontSize: "13px",
                letterSpacing: "0.02em",
                textAlign: "center",
            })}
        >
            Client version: {CLIENT_BUILD_ID}
        </div>
    );
}
